import PropTypes from 'prop-types';

const Checkbox = ({ id, checked = false, onChange, disabled = false, showDash = false, label, ...props }) => {
	const labelClasses = ['checkbox-label', disabled && 'checkbox-label-disabled'].filter(Boolean).join(' ');

	return (
		<div className="flex items-start">
			<input
				type="checkbox"
				id={id}
				checked={checked}
				onChange={(e) => onChange?.(e.target.checked)}
				disabled={disabled}
				ref={(input) => {
					if (input) input.indeterminate = showDash;
				}}
				className="checkbox"
				{...props}
			/>
			{label && (
				<label htmlFor={id} className={labelClasses}>
					{label}
				</label>
			)}
		</div>
	);
};

Checkbox.propTypes = {
	id: PropTypes.string.isRequired,
	checked: PropTypes.bool,
	onChange: PropTypes.func,
	disabled: PropTypes.bool,
	// Renders a dash instead of the checkmark, overriding `checked` (used for things as some items selected, since we need another symbol there)
	showDash: PropTypes.bool,
	label: PropTypes.node,
};

export default Checkbox;
